import React, { useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap/dist/css/bootstrap.min.css";
import Loader from "../../components/loader/Loader";

const IframePage = ({ url }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div style={{ height: "100%", width: "100%", position: "relative",backgroundColor: "#f8f9fb",}}>
      
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "#f8f9fb",
            zIndex: 10,
          }}
        >
          <div className="text-center">
            <Loader/>
          </div>
        </div>
      )}

      <iframe
        src={url}
        title="iframe-content"
        onLoad={() => setLoading(false)}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
};

export default IframePage;